module.exports = __webpack_public_path__ + "img/SKMA_E.251078ba.png";